import { success as successNotif, error as errorNotif, info as infoNotif } from "react-notification-system-redux";
import { ZendeskAPI } from "react-zendesk";

import { config } from "_config";
import { ERROR_INCORECT_SET_PASSWORD_TOKEN } from "_constants";
import { history } from "_helpers";
import { userService } from "_services";

import { userTypes } from "../types";

export const userActions = {
  signin,
  resetPassword,
  resetPasswordSuccessModalClose,
  login,
  loginByToken,
  loginResetError,
  logout,
  updateInfo,
};

function signin({ token, password, category }) {
  return (dispatch) => {
    dispatch(request());

    userService.signin({ token, password, category }).then(
      () => {
        dispatch(
          successNotif({
            title: "Success",
            message: "Password successfully set. Now you can login use your associated e-mail and password.",
            autoDismiss: 0,
          })
        );
        dispatch(success());
        history.push(config.publicUrl + "/login");
      },
      (error) => {
        if (!error.isResponse) {
          userService.crmSignin({ token, password, category }).then(
            () => {
              dispatch(
                successNotif({
                  title: "Success",
                  message: "Password successfully set. Now you can login use your associated e-mail and password.",
                  autoDismiss: 0,
                })
              );
              dispatch(success());
              history.push(config.publicUrl + "/login");
            },
            (error) => {
              dispatch(errorNotif({ title: "Error", message: ERROR_INCORECT_SET_PASSWORD_TOKEN, autoDismiss: 0 }));
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(errorNotif({ title: "Error", message: ERROR_INCORECT_SET_PASSWORD_TOKEN, autoDismiss: 0 }));
          dispatch(
            infoNotif({
              title: "Info",
              message:
                "You can try to login if already set the password using your associated e-mail and password. If you do not have your password, please click 'Forgot Your Password'.",
              autoDismiss: 0,
            })
          );
          dispatch(failure(error.toString()));
          history.push(config.publicUrl + "/login");
        }
      }
    );
  };

  function request() {
    return { type: userTypes.SIGN_IN_REQUEST };
  }
  function success() {
    return { type: userTypes.SIGN_IN_SUCCESS };
  }
  function failure(error) {
    return { type: userTypes.SIGN_IN_FAILURE, error };
  }
}

function resetPassword({ email, category }) {
  return (dispatch) => {
    dispatch(request());

    userService.resetPassword({ email, category }).then(
      () => {
        dispatch(success());
      },
      (error) => {
        if (!error.isResponse) {
          userService.crmResetPassword({ email, category }).then(
            () => {
              dispatch(success());
            },
            (error) => {
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: userTypes.RESET_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userTypes.RESET_PASSWORD_SUCCESS };
  }
  function failure(payload) {
    return { type: userTypes.RESET_PASSWORD_FAILURE, payload };
  }
}

function resetPasswordSuccessModalClose() {
  return (dispatch) => dispatch({ type: userTypes.RESET_PASSWORD_CLOSE });
}

function login(username, password, category) {
  return (dispatch) => {
    dispatch(request());

    userService.login(username, password, category).then(
      (user) => {
        localStorage.setItem("trademark-membership-user", JSON.stringify(user));
        userService.getMe().then(
          (userdetail) => {
            localStorage.setItem("userInfo", JSON.stringify(userdetail));
            dispatch(success(userdetail));
            history.push(config.publicUrl + "/");
          },
          (error) => {
            dispatch(failure(error.toString()));
          }
        );
      },
      (error) => {
        if (!error.isResponse) {
          userService.crmLogin(username, password, category).then(
            (user) => {
              localStorage.setItem("trademark-membership-user", JSON.stringify(user));
              userService.crmGetMe().then((userdetail) => {
                localStorage.setItem("userInfo", JSON.stringify(userdetail));
                dispatch(success(userdetail));
                history.push(config.publicUrl + "/");
              });
            },
            (error) => {
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: userTypes.LOGIN_REQUEST };
  }
  function success(payload) {
    return { type: userTypes.LOGIN_SUCCESS, payload };
  }
  function failure(error) {
    return { type: userTypes.LOGIN_FAILURE, error };
  }
}

function loginByToken(token) {
  return (dispatch) => {
    dispatch(request());

    const user = { token };
    localStorage.setItem("trademark-membership-user", JSON.stringify(user));

    userService.getMe().then(
      (userdetail) => {
        localStorage.setItem("userInfo", JSON.stringify(userdetail));
        dispatch(success(userdetail));
        history.push(config.publicUrl + "/");
      },
      (error) => {
        if (!error.isResponse) {
          userService.crmGetMe().then(
            (userdetail) => {
              localStorage.setItem("userInfo", JSON.stringify(userdetail));
              dispatch(success(userdetail));
              history.push(config.publicUrl + "/");
            },
            (error) => {
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: userTypes.LOGIN_REQUEST };
  }
  function success(payload) {
    return { type: userTypes.LOGIN_SUCCESS, payload };
  }
  function failure(error) {
    return { type: userTypes.LOGIN_FAILURE, error };
  }
}

function loginResetError() {
  return (dispatch) => dispatch({ type: userTypes.LOGIN_RESET_ERROR });
}

function logout() {
  ZendeskAPI(function () {
    ZendeskAPI("webWidget", "hide");
  });

  userService.logout();
  history.push(config.publicUrl + "/login");
  return { type: userTypes.LOGOUT };
}

function updateInfo(user) {
  return (dispatch) => {
    dispatch(request());

    userService.updateInfo(user).then(
      (userInfo) => {
        dispatch(successNotif({ title: "Success", message: "User information has been successfully updated" }));
        dispatch(success(userInfo));
      },
      (error) => {
        if (!error.isResponse) {
          userService.crmUpdateInfo(user).then(
            (userInfo) => {
              dispatch(successNotif({ title: "Success", message: "User information has been successfully updated" }));
              dispatch(success(userInfo));
            },
            (error) => {
              dispatch(errorNotif({ title: "Error", message: error?.message || "Something went wrong,,," }));
              dispatch(failure());
            }
          );
        } else {
          dispatch(errorNotif({ title: "Error", message: error?.message || "Something went wrong,,," }));
          dispatch(failure());
        }
      }
    );
  };

  function request() {
    return { type: userTypes.USER_UPDATE_INFO_REQUEST };
  }
  function success(payload) {
    return { type: userTypes.USER_UPDATE_INFO_SUCCESS, payload };
  }
  function failure() {
    return { type: userTypes.USER_UPDATE_INFO_FAILURE };
  }
}
